import { render, staticRenderFns } from "./socialMedia.vue?vue&type=template&id=0b4dfa01&scoped=true"
import script from "./socialMedia.vue?vue&type=script&lang=js"
export * from "./socialMedia.vue?vue&type=script&lang=js"
import style0 from "./socialMedia.vue?vue&type=style&index=0&id=0b4dfa01&prod&lang=css"
import style1 from "./socialMedia.vue?vue&type=style&index=1&id=0b4dfa01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4dfa01",
  null
  
)

export default component.exports